var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 2400 2400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "2395,627.8 1800.1,1021.9 1800.1,1471.8 2395,1816  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1535.9,1791.8c0,40.9-33.1,74-74,74H79c-40.9,0-74-33.1-74-74V606.7c0-40,32.4-72.5,72.5-72.5 c0.5,0,1,0,1.5,0h1383c40-0.8,73.1,30.9,74,70.9c0,0.5,0,1,0,1.5V1791.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/videoCamera.7ee52c176a6b35703b28c4f353300328.svg";
export { ForwardRef as ReactComponent };